import { RouteObject } from "react-router-dom";
import ReportListPage from "./pages/reporting-and-analytics/report-list/report-list.page";
import NotFoundPage from "../shared/pages/not-found/not-found.page";
import ReportDataPage from "./pages/reporting-and-analytics/report-data/report-data.page";
import ReportingAndAnalyticsPage from "./pages/reporting-and-analytics/reporting-and-analytics.page";
import GrossToNetPage from "./pages/gross-to-net/gross-to-net.page";
import TaskImportPage from "./pages/task-import/task-import.page";
import QueuedReportsPage from "./pages/queued-reports/queued-reports.page";

export const privateRoutes: RouteObject[] = [
  // { path: "about", element: <AboutPage /> },
  // { path: "contacts", element: <ContactsPage /> },

  {
    path: "queued-reports",
    element: <QueuedReportsPage />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "forecasting",
    element: <ReportListPage />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "gross-to-net",
    element: <GrossToNetPage />,
    errorElement: <NotFoundPage />,
  },
  {
    path: "reporting-and-analytics",
    element: <ReportingAndAnalyticsPage />,
    errorElement: <NotFoundPage />,
    children: [
      { path: "queued-reports", element: <QueuedReportsPage /> },
      { path: "forecasting", element: <TaskImportPage /> },
      { path: "gross-to-net", element: <GrossToNetPage /> },
      { path: "report-list", element: <ReportListPage /> },
      { path: "report-data", element: <ReportDataPage /> },
    ],
  },
];
